import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './utils/registerServiceWorker';

const rootElement = document.getElementById('root');

// When the page is served from a react-snap pre-render, the DOM is already
// populated and we must hydrate instead of mount — otherwise React will throw
// away the SSR markup, losing the SEO benefit and causing a visible flash.
// In dev / plain CRA builds, root has no children → fall back to createRoot.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Register service worker (production only — see file for details).
registerServiceWorker();
